/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Pricing
 * The Selling Partner API for Pricing helps you programmatically retrieve product pricing and offer information for Amazon Marketplace products.
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Indicates whether to request Consumer or Business offers. Default is Consumer.
 */

export const CustomerType = {
    Consumer: 'Consumer',
    Business: 'Business',
} as const;

export type CustomerType = typeof CustomerType[keyof typeof CustomerType];



